import type { GraphNode, Vec3 } from 'playcanvas';

/** Avoid idle transform writes without overlooking movement of the billboard or its ancestors. */
export class BillboardPoseTracker {
    private readonly world = new Float32Array(16);
    private cameraX = NaN;
    private cameraY = NaN;
    private cameraZ = NaN;

    /** Returns true when the caller must request a frame (getWorldTransform clears dirty flags). */
    update(entity: GraphNode, cameraPosition: Vec3): boolean {
        const world = entity.getWorldTransform().data;
        if (cameraPosition.x === this.cameraX && cameraPosition.y === this.cameraY && cameraPosition.z === this.cameraZ &&
            world.every((value, i) => value === this.world[i])) return false;

        // Preserve the original orientation operations, including parent-space conversion.
        entity.lookAt(cameraPosition);
        entity.rotateLocal(90, 180, 0);
        this.world.set(entity.getWorldTransform().data);
        this.cameraX = cameraPosition.x;
        this.cameraY = cameraPosition.y;
        this.cameraZ = cameraPosition.z;
        return true;
    }

    reset(): void { this.cameraX = NaN; }
}
